import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { loadChatWidget } from "@/lib/thirdParty";

/**
 * Lightweight local stand-in for the LeadConnector chat bubble.
 * Occupies the exact footprint of the real widget so nothing shifts, and
 * swaps itself out for the real widget the moment the visitor clicks.
 */
const ChatLauncher = () => {
  const [loading, setLoading] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!loading) return;
    let cancelled = false;
    loadChatWidget().then(() => {
      if (cancelled) return;
      // Give the widget a beat to mount its own bubble before removing ours.
      window.setTimeout(() => setHidden(true), 1200);
    });
    return () => {
      cancelled = true;
    };
  }, [loading]);

  if (hidden) return null;

  return (
    <button
      type="button"
      aria-label="Open chat"
      onClick={() => setLoading(true)}
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-105 motion-reduce:transition-none motion-reduce:hover:scale-100"
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
    </button>
  );
};

export default ChatLauncher;
